const { API_BASE_URL, BACKEND_ORIGIN } = require("../../api.config")

export function resolveApiOrigin() {
  const configuredOrigin = process.env.VUE_APP_API_ORIGIN
  if (configuredOrigin) {
    return configuredOrigin.replace(/\/$/, "")
  }

  const configuredBase = process.env.VUE_APP_API_BASE || process.env.VUE_APP_API_BASE_URL
  if (configuredBase && /^https?:\/\//i.test(configuredBase)) {
    return new URL(configuredBase).origin
  }

  return BACKEND_ORIGIN
}

export function resolveApiBaseUrl() {
  const configuredBase = process.env.VUE_APP_API_BASE || process.env.VUE_APP_API_BASE_URL
  if (configuredBase) {
    return configuredBase.replace(/\/$/, "")
  }
  return API_BASE_URL
}

export function resolveBackendAssetUrl(value) {
  const current = String(value || "").trim()
  if (!current || current.startsWith("data:") || current.startsWith("blob:")) {
    return current
  }
  if (current.startsWith("//")) {
    return current
  }

  if (/^https?:\/\//i.test(current)) {
    const parsed = new URL(current)
    if (parsed.origin !== BACKEND_ORIGIN && parsed.origin !== resolveApiOrigin()) {
      return current
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  }

  const localPath = current.startsWith("/") ? current : `/${current}`
  return localPath
}
